function isLocalHost(hostname = window.location.hostname) {
  return ['localhost', '127.0.0.1', '', '::1'].includes(hostname)
}

function getChannelParam() {
  const params = new URLSearchParams(window.location.search);
  return params.get('channel');
}

function appendChannel(url, channel) {
  if (!channel) return url;
  return url + (url.includes('?') ? '&' : '?') + 'channel=' + encodeURIComponent(channel);
}

function createLinkConfig () {
  const channel = getChannelParam();
  let linkConfig = {
    web: "/",
    h5: "/",
    online: "https://shunlong.s5.udesk.cn/im_client/?web_plugin_id=1812&group_id=1048",
    login: "https://fo.wsgoldfo003.com/Frontoffice/",
    disclaimer: `/singlepage/disclaimer`,
    risk: `/singlepage/risk_disclosure`,
    agreement: `/singlepage/client_agreement`,
    policy: `/singlepage/privacy_policy`,
    android: [
      "https://downloads.akklldownload.com/source/material/WSJY_tuijian.apk",
      "https://mp-18b59665-8ace-4294-a961-e5d5164f6bef.cdn.bspapp.com/GW/2025_7/WSJY_tuijian_v325.apk",
    ],
    android_backup: 
      "https://mp-18b59665-8ace-4294-a961-e5d5164f6bef.cdn.bspapp.com/GW/2025_7/WSJY_tuijian_v325.apk",
  };

  /**
   * 本地开发或者UAT 设定:
   * isLocalHost() || window.location.hostname.includes("atbgovernor")
   * 
   * 其余视为正式环境，动态域名
   */
  if (isLocalHost() || window.location.hostname.includes("atbgovernor")) {
    linkConfig.web = "https://wasin.atbgovernor.com";
    linkConfig.h5 = appendChannel("http://h5-wasin-official.atbgovernor.com/?utm_source=tuijian", channel);
  } else {
    const baseDomain = window.location.hostname.replace(/^[^.]+\./, '');
    linkConfig.h5 = appendChannel(`${window.location.protocol}//h5.${baseDomain}/?utm_source=tuijian`, channel);
  }

  return linkConfig;
}

const CHANNEL_BRAND_MAP = {
  'wwjy-ios': 'wwjy',
  'wszt-ios': 'wszt',
};

export const brandNames = {
  wasin: '华信金业',
  wwjy: '华欣金业',
  wszt: '华信智投',
};

export const brandNavLogos = {
  wasin: '/logo.png',
  wwjy: '/logo-wwjy.png',
  wszt: '/logo-wszt.png',
};

export const brandIconLogos = {
  wasin: '/icon_logo.png',
  wwjy: '/icon_logo-wwjy.png',
  wszt: '/icon_logo-wszt.png',
};

const _channelParam = getChannelParam();
export const brandKey = (_channelParam && CHANNEL_BRAND_MAP[_channelParam.toLowerCase()]) || 'wasin';

const sourceUrl = "_s_u_l_";
const linkConfig = createLinkConfig();
const signature = "wsjy";
export { linkConfig, sourceUrl, signature };
